<template>
    <div
        v-if="!editable"
        :class="{'uk-form-row': asRow, 'uk-height-1-1': !!height}"
    >
        <slot name="read_only">
            <label
                v-if="has_label"
                class="uk-form-label"
                :for="identifier"
            >
                <slot name="label"></slot>
            </label>
            <div class="uk-form-controls uk-form-controls-text">
                {{ value }}
            </div>
        </slot>
    </div>
    <div
        v-else
        :class="{'uk-form-row': asRow, 'uk-height-1-1': !!height}"
    >
        <label
            v-if="has_label"
            class="uk-form-label"
            :for="identifier"
        >
            <slot name="label">{{ name }}</slot>
            <loader
                v-if="waiting"
                size="xs"
                color="gray"
                class="ml-2"
            />
        </label>
        <div
            :class="{'uk-height-1-1': !!height}"
            class="uk-form-controls"
        >
            <slot></slot>
        </div>
        <div
            v-if="!!error && (error !== true)"
            :id="`${identifier}-description`"
            aria-live="assertive"
            class="uk-form-help-block uk-text-danger"
        >
            {{ error }}
        </div>
        <div
            v-else-if="has_slot('hint')"
            :id="`${identifier}-description`"
            aria-live="polite"
            class="uk-form-help-block uk-text-muted"
        >
            <slot name="hint"></slot>
        </div>
    </div>
</template>

<script>
import is_nibnut_component from "../mixins/IsNibnutComponent"

import Loader from "./Loader"

export default {
    name: "FormGroup",
    mixins: [is_nibnut_component],
    components: {
        Loader
    },
    computed: {
        has_label () {
            return this.has_slot("label")
        },
        has_hint () {
            return this.has_slot("hint")
        }
    },
    props: {
        id: {
            type: String,
            validator: prop => !!prop
        },
        name: {
            type: String,
            validator: prop => !!prop,
            required: true
        },
        value: {
            default: ""
        },
        required: {
            type: Boolean,
            required: true
        },
        editable: {
            type: Boolean,
            default: true
        },
        waiting: {
            type: Boolean,
            default: false
        },
        error: {
            validator: prop => (typeof prop === "boolean") || (typeof prop === "string"),
            default: ""
        },
        height: {
            type: String,
            default: ""
        },
        asRow: {
            type: Boolean,
            default: true
        }
    }
}
</script>

<style lang="less">
.uk-form-row {
    & > .uk-form-label {
        & > .loader {
            display: inline-block;
        }
    }
}
</style>
